import { IMessage } from './message';
import { IMessageContext, MiddleWare } from './type';

type ComposeRet<T extends IMessage> = (
  ctx: IMessageContext<T>,
) => Promise<IMessageContext<T>>;

/**
 * @description 中间件类
 */
export class Executer<T extends IMessage> {
  private middlewareList: MiddleWare<T>[] = [];
  public use(middleware: MiddleWare<T>): void {
    if (typeof middleware !== 'function') {
      throw new TypeError('middleware must be a function');
    }
    this.middlewareList.push(middleware);
  }
  public useSome(middlewares: MiddleWare<T>[]): void {
    middlewares.forEach(middleware => this.use(middleware));
  }
  public compose(): ComposeRet<T> {
    return async ctx => {
      let process = 0; //记录中间件执行进度
      const dispatch = async (i: number) => {
        const asyncFunc = this.middlewareList[i];
        if (!asyncFunc) return null;
        try {
          await asyncFunc(ctx, async function next() {
            process++;
            try {
              await dispatch(i + 1);
            } catch (error) {
              throw error;
            }
          });
        } catch (error) {
          throw `第${process}个--${this.middlewareList[process].name ||
            '未知'}中间件出错了,${error}`;
        }
      };
      try {
        await dispatch(0);
      } catch (error) {
        throw error;
      }
      return ctx;
    };
  }
}
